import ErrorText from "app/components/form/error-text";
import { Trans } from "react-i18next";
import classNames from "classnames";
import { Field } from "formik";
import PropTypes from "prop-types";

const InputField = ({
  id,
  name,
  type,
  label,
  placeholder,
  optional,
  prefix,
  language,
  additionalClassName,
}) => {
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className="text-sm">
        <span className="font-semibold">{label}</span>
        {optional && (
          <span>
            &nbsp;&#40;
            <Trans>optional</Trans>
            &#41;
          </span>
        )}
      </label>
      <div className="relative" lang={language}>
        <Field
          type={type}
          id={id}
          name={name}
          placeholder={placeholder}
          className={classNames(
            "w-full rounded-full border px-4 py-2 text-base leading-5 md:text-sm",
            { "ltr:pl-7 rtl:pr-6": prefix },
            additionalClassName
          )}
        />
        {prefix && (
          <span className="absolute top-1/2 -translate-y-1/2 ltr:left-3 rtl:right-3">
            {prefix}
          </span>
        )}
      </div>
      <ErrorText name={name} />
    </div>
  );
};

InputField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  optional: PropTypes.bool,
  prefix: PropTypes.string,
  language: PropTypes.string,
  additionalClassName: PropTypes.string,
};

export default InputField;
